module.exports = __webpack_public_path__ + "img/caas1m-m@1.ed5d1107.jpg";